var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 mx-auto mt-5"},[_c('h3',[_vm._v("Thank You For Your Inquiry!")]),_c('p',[_vm._v(" We aim to provide the most comprehensive, coherent, and customizable regulatory alerts in the world. We will review your request and get back to you ASAP. Thanks for your business! ")])])])])
}]

export { render, staticRenderFns }